import { Text } from "@meditect/medibase-components";

export const SalesCannotCloseSaleWithNotEnoughPaidError = () => {
  return <Text>Il y a un reste à régler</Text>;
};
